import { combineReducers } from "redux";
import loggedUser from "./loggedUser";
import celebData from "./celebData";
import activeCelebData from "./activeCelebData";
import activeCelebId from "./activeCelebId";
import bannerDelay from "./bannerDelay";
import bannerModal from "./bannerModal";
import searchWindow from "./searchWindow";
import activeImage from "./activeImage";
import loggedAdmin from "./loggedAdmin";
import adminLoginError from "./adminLoginError";
import adminPanelSidebar from "./adminPanelSidebar";
import aboutImageDetailsToggle from "./aboutImageDetailsToggle";
import menuBarToggle from "./menuBarToggle";
import profileSideBarToggle from "./profileSideBarToggle";
import activeAccountTab from "./activeAccountTab";
import walletMenuBar from "./walletMenuBar";
import adminActiveCelebList from "./adminActiveCelebList";
import activeAdminDashboard from "./activeAdminDashboard";
import adminSuccessMsg from "./adminSuccessMsg";
import adminErrorMsg from "./adminErrorMsg";
import bidPanel from "./bidPanel";
import notification from "./notification";

const rootReducers = combineReducers({
  loggedUser,
  celebData,
  activeCelebData,
  activeCelebId,
  bannerDelay,
  bannerModal,
  searchWindow,
  activeImage,
  loggedAdmin,
  adminLoginError,
  adminPanelSidebar,
  aboutImageDetailsToggle,
  menuBarToggle,
  profileSideBarToggle,
  activeAccountTab,
  walletMenuBar,
  adminActiveCelebList,
  activeAdminDashboard,
  adminSuccessMsg,
  adminErrorMsg,
  bidPanel,
  notification,
});
export default rootReducers;
